module.exports = __webpack_public_path__ + "static/naturalist-02-a2a1c9cf147e3b95b019be769c4083ad.png";